import React from 'react';
import { Rocket, Star, Heart, Users } from 'lucide-react';
import { SunburstRays } from '../components/SunburstRays';

export const About = () => {
  return (
    <div className="min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-fredoka font-bold text-[#1A1A2E] mb-6" data-testid="about-page-title">
            Acerca de Diversytoys
          </h1>
          <p className="text-xl text-[#4A4A6A] font-quicksand max-w-3xl mx-auto">
            Más de 18 años llevando alegría y diversión a las familias
          </p>
        </div>

        {/* Story Section */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl mb-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1637988936322-016302f3226d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHwzZCUyMGNhcnRvb24lMjByb2NrZXQlMjBzcGFjZSUyMGJyaWdodCUyMGNvbG9yc3xlbnwwfHx8fDE3NjkzNzcyOTB8MA&ixlib=rb-4.1.0&q=85"
                alt="Diversytoys Story"
                className="rounded-2xl shadow-lg w-full"
              />
            </div>
            <div>
              <h2 className="text-3xl sm:text-4xl font-fredoka font-bold text-[#1A1A2E] mb-6">
                Nuestra Historia
              </h2>
              <p className="text-lg text-[#4A4A6A] font-quicksand leading-relaxed mb-4">
                Desde 2007, Diversytoys se ha dedicado a ofrecer los mejores juguetes para niños de todas las edades.
                Comenzamos como una pequeña juguetería local en Rionegro, Antioquia, con el sueño de llevar sonrisas
                a cada hogar.
              </p>
              <p className="text-lg text-[#4A4A6A] font-quicksand leading-relaxed">
                Hoy, seguimos comprometidos con ofrecer productos de calidad que estimulan la imaginación,
                el aprendizaje y la diversión. Cada juguete en nuestra tienda es cuidadosamente seleccionado
                pensando en el desarrollo y la felicidad de los niños.
              </p>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg text-center" data-testid="value-card-quality">
            <div className="w-16 h-16 bg-[#00C2CB]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Star className="w-8 h-8 text-[#00C2CB]" />
            </div>
            <h3 className="font-fredoka font-bold text-xl text-[#1A1A2E] mb-3">Calidad</h3>
            <p className="text-[#4A4A6A] font-quicksand">
              Productos cuidadosamente seleccionados para garantizar seguridad y diversión.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg text-center" data-testid="value-card-variety">
            <div className="w-16 h-16 bg-[#FFD700]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Rocket className="w-8 h-8 text-[#FFD700]" />
            </div>
            <h3 className="font-fredoka font-bold text-xl text-[#1A1A2E] mb-3">Variedad</h3>
            <p className="text-[#4A4A6A] font-quicksand">
              Amplio catálogo para todas las edades y gustos, desde bebés hasta pre-adolescentes.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg text-center" data-testid="value-card-passion">
            <div className="w-16 h-16 bg-[#FF6B00]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Heart className="w-8 h-8 text-[#FF6B00]" />
            </div>
            <h3 className="font-fredoka font-bold text-xl text-[#1A1A2E] mb-3">Pasión</h3>
            <p className="text-[#4A4A6A] font-quicksand">
              Amamos lo que hacemos y se refleja en cada detalle de nuestro servicio.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg text-center" data-testid="value-card-community">
            <div className="w-16 h-16 bg-[#00C2CB]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="w-8 h-8 text-[#00C2CB]" />
            </div>
            <h3 className="font-fredoka font-bold text-xl text-[#1A1A2E] mb-3">Comunidad</h3>
            <p className="text-[#4A4A6A] font-quicksand">
              Somos parte de la comunidad y nos enorgullece servir a nuestras familias.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="relative bg-gradient-to-br from-[#00C2CB]/10 via-[#FFD700]/10 to-[#FF6B00]/10 rounded-3xl p-12 text-center overflow-hidden">
          {/* Animated Sunburst from bottom-left */}
          <SunburstRays position="bottom-left" size="medium" speed="slow" opacity={0.1} />
          
          <h2 className="text-3xl sm:text-4xl font-fredoka font-bold text-[#1A1A2E] mb-4 relative z-10">
            Únete a Nuestra Familia
          </h2>
          <p className="text-lg text-[#4A4A6A] font-quicksand mb-8 max-w-2xl mx-auto">
            Descubre por qué miles de familias confían en nosotros para los mejores juguetes.
          </p>
          <button
            onClick={() => window.location.href = '/products'}
            className="bg-[#FF6B00] text-white px-8 py-4 rounded-full font-fredoka font-bold text-lg hover:bg-[#FF6B00]/90 hover:scale-105 transition-all duration-300 shadow-lg"
            data-testid="about-cta-button"
          >
            Explorar Productos
          </button>
        </div>
      </div>
    </div>
  );
};